"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var union_1 = __importDefault(require("lodash/union"));
var reducers_1 = require("../reducers");
var _1 = require(".");
var renderer_1 = require("./renderer");
/**
 * Map state to cell props.
 *
 * @param state JSONForms state tree
 * @param ownProps any own props
 * @returns {StatePropsOfCell} state props of a cell
 */
exports.mapStateToCellProps = function (state, ownProps) {
    var id = ownProps.id, schema = ownProps.schema, path = ownProps.path, uischema = ownProps.uischema;
    var rootData = reducers_1.getData(state);
    var visible = ownProps.visible !== undefined
        ? ownProps.visible
        : _1.isVisible(uischema, rootData);
    var enabled = ownProps.enabled !== undefined
        ? ownProps.enabled
        : _1.isEnabled(uischema, rootData);
    var errors = _1.formatErrorMessage(union_1.default(reducers_1.getErrorAt(path, schema)(state).map(function (error) { return error.message; })));
    var isValid = isEmpty_1.default(errors);
    var rootSchema = reducers_1.getSchema(state);
    return {
        data: _1.Resolve.data(rootData, path),
        visible: visible,
        enabled: enabled,
        id: id,
        path: path,
        errors: errors,
        isValid: isValid,
        schema: schema,
        uischema: uischema,
        config: reducers_1.getConfig(state),
        rootSchema: rootSchema
    };
};
exports.mapStateToDispatchCellProps = function (state, ownProps) {
    var props = exports.mapStateToCellProps(state, ownProps);
    var renderers = ownProps.renderers, otherOwnProps = __rest(ownProps, ["renderers"]);
    return __assign({}, props, otherOwnProps, { cells: state.jsonforms.cells || [] });
};
/**
 * Default mapStateToCellProps for enum cell. Options is used for populating dropdown list
 * @param state
 * @param ownProps
 * @returns {StatePropsOfEnumCell}
 */
exports.defaultMapStateToEnumCellProps = function (state, ownProps) {
    var props = exports.mapStateToCellProps(state, ownProps);
    var options = ownProps.options !== undefined ? ownProps.options : props.schema.enum;
    return __assign({}, props, { options: options });
};
/**
 * Synonym for mapDispatchToControlProps.
 *
 * @type {(dispatch) => {handleChange(path, value): void}}
 */
exports.mapDispatchToCellProps = renderer_1.mapDispatchToControlProps;
/**
 * Default dispatch to control props which can be customized to set handleChange action
 *
 */
exports.defaultMapDispatchToControlProps = 
// TODO: ownProps types
function (dispatch, ownProps) {
    var handleChange = exports.mapDispatchToCellProps(dispatch).handleChange;
    return {
        handleChange: ownProps.handleChange || handleChange
    };
};
//# sourceMappingURL=cell.js.map